<template>
  <div class="module-detail-container">
    <!-- 主内容区 -->
    <div class="module-content">
      <!-- 1. 模块专属图片 -->
      <div class="module-specific-image">
        <img :src="currentModule.url" :alt="currentModule.title" />
        <div class="linkDom">
          <p @click="$router.push('/Home/supplyDemand/supplyHall')" class="linkDom01"><i class="el-icon-s-order"></i>发布供应信息</p>
          <p @click="$router.push('/Home/supplyDemand/purchaseHall')" class="linkDom02"><i class="el-icon-s-order"></i>发布需求信息</p>
        </div>
      </div>

      <!-- 2. 公用空状态图片 -->
      <!-- <div class="empty-state-image">
        <img src="@/assets/recycling/index/detail-empty.png" alt="空状态" />
      </div> -->

      <!-- 3. 开发中提示 -->
      <!-- <div class="development-notice">
        <p>正在开发中...</p>
      </div> -->
    </div>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import { scrollTop } from '@/util/scrollTop';
export default {
  components: {
    bottomUrl,
  },
  data() {
    return {
      // 8个模块的配置数据
      currentModule: {
        title: '供需信息',
        url: require('@/assets/recycling/index/supplyAndDemand.svg'),
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
/* 基础样式 */
.module-detail-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.module-detail-container {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 90px);
  overflow-y: auto;
  position: relative;
}

.module-content {
  width: 100%;
  padding-bottom: 32px; /* 为底部组件预留空间 */
}

/* 模块专属图片样式 */
.module-specific-image {
  width: 100%;
  margin: 0 auto 10px;
  display: block;
  position: relative;
}
.linkDom {
  position: absolute;
  display: flex;
  left: 44%;
  top: 52.5%;
  .linkDom01,
  .linkDom02 {
    font-size: 16px;
    cursor: pointer;
    color: #3a8ee6;
    text-decoration: underline;
  }
  .linkDom02 {
    margin-left: 20px;
  }
}
.secImg {
  width: 100%;
}
.topImg {
  object-fit: cover;
  width: 100%;
  height: 730px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .module-content {
    padding: 1.5rem 1rem 200px;
  }
}

@media (max-width: 768px) {
  .module-detail-container {
    height: auto;
  }
  .module-content {
    height: 100%;
    padding: 0 16px 180px;
    background-size: 90% auto; /* 移动端适当缩小 */

    .linkDom {
      position: absolute;
      top: 100%;
      left: 0;
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 16px;
      .linkDom01, .linkDom02 {
        width: 48%;
        font-size: 12px !important;
        text-decoration: none;
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #1abe6b;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        padding: 12px 20px;
        border-radius: 4px;
      }
    }
  }
}

@media (max-width: 480px) {
  .module-content {
    background-size: 95% auto; /* 小屏幕进一步调整 */
  }
}
</style>
